import './SocialNav.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import FB from '../../../resources/icons/login_fb_new.svg';
import GP from '../../../resources/icons/login_gp_new.svg';
import iconTw from '../../../resources/icons/login_tw.svg';
// import GoogleLogin from 'react-google-login';
import { useGoogleLogin } from '@react-oauth/google';
// import FacebookLogin from 'react-facebook-login';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { setUserCookie } from '../../../utils/setUserCookie';
import { qsToObject } from '../../../utils/querystring';
import { canUseDOM, get } from '../../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
const SocialNav = _ref => {
  let {
    buttons,
    successFunction,
    showError,
    ApiError,
    loadingFunc,
    facebookAppId,
    googleClientId,
    analytics = {},
    className,
    customAnalyticsFunc,
    isBtnContainerHorizontal = false,
    getEvisaToken,
    requestEvisaToken = false,
    eventsAnalytics,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  // const identityGlobal = 'https://replaceidentityGlobal';
  // const client_id = 'replaceint2';

  const sendAnalytics = (platform, label) => {
    const {
      socialPlatform = null,
      params
    } = analytics;
    if (socialPlatform !== undefined || socialPlatform !== null) {
      if (customAnalyticsFunc) {
        customAnalyticsFunc(label);
      } else {
        tealiumClickFunc(tealiumMergeClickData(socialPlatform, params), `Connect to ${platform}`);
      }
    }
  };
  let twitter_callback = '';
  if (canUseDOM) {
    twitter_callback = window.location.origin + '/signin-twitter';
  }

  // get(sitecoreContext, 'configuration.globalApi.identityGlobal');

  const client_secret = get(sitecoreContext, 'configuration.globalApi.clientSecret') || 'replacesecret';
  const client_id = get(sitecoreContext, 'configuration.globalApi.clientId') || 'replaceint2';
  const identityGlobal = get(sitecoreContext, 'configuration.globalApi.identityGlobal') || 'https://replaceidentityGlobal';
  const socialLoginApi = function (response, grantType, socialLabel) {
    let twitterObj = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    if (response && response.length) {
      let myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');
      let urlencoded = new URLSearchParams();
      urlencoded.append('grant_type', grantType);
      urlencoded.append('client_id', client_id);
      urlencoded.append('client_secret', client_secret);
      urlencoded.append('scope', 'api.read    IdentityServerApi   offline_access');
      if (twitterObj) {
        urlencoded.append('access_token', twitterObj.token);
        urlencoded.append('token_secret', twitterObj.tokenSecret);
      } else if (socialLabel === 'google') {
        urlencoded.append('access_token', response);
      } else {
        urlencoded.append('token', response);
      }
      let requestOptions = {
        method: 'POST',
        body: urlencoded,
        headers: myHeaders,
        redirect: 'follow'
      };
      let statusCode = 0;
      fetch(`${identityGlobal}/connect/token`, requestOptions).then(response => {
        loadingFunc(false);
        statusCode = response.status;
        return response.text();
      }).then(result => {
        let responseObj;
        if (result) {
          responseObj = JSON.parse(result);
        }
        if (statusCode === 200) {
          if (responseObj.access_token) {
            if (eventsAnalytics) {
              tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['loginSuccess'], params), socialLabel);
            }
            setUserCookie(responseObj, socialLabel);
            if (requestEvisaToken && getEvisaToken) {
              getEvisaToken(responseObj.access_token);
            } else {
              if (successFunction) {
                successFunction(socialLabel);
              }
            }
          } else {
            throw Error(ApiError);
          }
        } else {
          throw Error(ApiError);
        }
      }).catch(error => {
        console.log('in socialLoginApi error: ', error);
        loadingFunc(false);
        showError('');
        console.error('social api status code', statusCode);
        if (statusCode === 0) {
          showError(ApiError);
        } else {
          showError(error.message);
        }
      });
    }
  };
  const responseGoogle = response => {
    if (response.error && response.error === 'idpiframe_initialization_failed') {
      return false;
    }
    showError('');
    if (response.access_token) {
      socialLoginApi(response.access_token, 'google_token', 'google');
    } else {
      if (response.error && response.error !== 'popup_closed_by_user') {
        showError(ApiError);
      }
      loadingFunc(false);
    }
  };
  const responseFacebook = response => {
    showError('');
    if (response.accessToken) {
      socialLoginApi(response.accessToken, 'facebook_token', 'facebook');
    } else {
      showError(ApiError);
      loadingFunc(false);
    }
  };
  const facebookClicked = label => {
    loadingFunc(true);
    sendAnalytics('Facebook', label);
  };
  const twitterPopupName = 'twitterPopop';
  const strWindowFeatures = 'toolbar=no, menubar=no, width=600, height=700, top=100, left=100';
  const closePopUp = () => {
    windowObjectReference && windowObjectReference.close();
  };
  const twitterOpen = () => {
    let base64Str = Buffer.from(`${client_id}:${client_secret}`).toString('base64');
    let myHeaders = new Headers();
    myHeaders.append('Authorization', 'Basic ' + base64Str);
    let requestOptions = {
      method: 'POST',
      headers: myHeaders,
      redirect: 'follow'
    };
    let statusCode = 0;
    return fetch(`${identityGlobal}/api/twitter/RequestToken?callback=${twitter_callback}`, requestOptions).then(response => {
      statusCode = response.status;
      return response.text();
    }, closePopUp).then(result => {
      let responseObj;
      if (result) {
        responseObj = JSON.parse(result);
      }
      if (statusCode === 200) {
        if (responseObj.isSuccess && responseObj.data && responseObj.data.oauthCallbackConfirmed) {
          return responseObj.data;
        } else {
          throw Error(ApiError);
        }
      } else {
        throw Error(ApiError);
      }
    }, closePopUp).catch(error => {
      console.log('twitter response error: ', error);
      console.error('twitter token status code', statusCode);
      closePopUp();
      if (statusCode === 0) {
        showError(ApiError);
      } else {
        showError(error.message);
      }
      loadingFunc(false);
      return false;
    });
  };
  let windowObjectReference = null;
  let previousUrl = null;
  let twitterResponseObj = null;
  const twitterPopupOpen = url => {
    window.removeEventListener('message', receiveTwitterAuth);
    if (windowObjectReference === null || windowObjectReference && windowObjectReference.closed) {
      windowObjectReference = window.open(url, twitterPopupName, strWindowFeatures);
    } else if (previousUrl !== url) {
      windowObjectReference = window.open(url, twitterPopupName, strWindowFeatures);
      windowObjectReference && windowObjectReference.focus();
    } else {
      windowObjectReference.focus();
    }
    window.addEventListener('message', event => receiveTwitterAuth(event), false);
    previousUrl = url;
    var pollTimer = setInterval(() => {
      if (windowObjectReference && windowObjectReference.closed !== false) {
        clearInterval(pollTimer);
        loadingFunc(false);
      }
    }, 400);
  };
  const receiveTwitterAuth = event => {
    if (canUseDOM) {
      if (event.origin !== window.location.origin) {
        loadingFunc(false);
        showError(ApiError);
        return;
      }
      let urlParams;
      if (event.data && event.data.length) {
        if (event.data.indexOf('oauth_token') !== -1 && event.data.indexOf('oauth_verifier') !== -1) {
          urlParams = qsToObject(event.data);
          sendFinalTwitterRequest(urlParams.oauth_token, urlParams.oauth_verifier).then(response => {
            if (response.token && response.tokenSecret) {
              socialLoginApi('none', 'twitter_token', 'twitter', response);
            }
          });
        }
      }
    }
  };
  const sendFinalTwitterRequest = (token, verifier) => {
    let base64Str = Buffer.from(`${client_id}:${client_secret}`).toString('base64');
    let myHeaders = new Headers();
    myHeaders.append('Authorization', 'Basic ' + base64Str);
    let requestOptions = {
      method: 'POST',
      headers: myHeaders,
      redirect: 'follow'
    };
    let statusCode = 0;
    return fetch(`${identityGlobal}/api/twitter/OauthVerifier?oauth_token=${token}&oauth_verifier=${verifier}`, requestOptions).then(response => {
      statusCode = response.status;
      return response.text();
    }).then(result => {
      let responseObj;
      if (result) {
        responseObj = JSON.parse(result);
      }
      if (statusCode === 200) {
        if (responseObj.isSuccess && responseObj.data && responseObj.data.token) {
          return responseObj.data;
        } else {
          throw Error(ApiError);
        }
      } else {
        throw Error(ApiError);
      }
    }).catch(error => {
      console.error('twitter token status code', statusCode);
      if (statusCode === 0) {
        showError(ApiError);
      } else {
        showError(error.message);
      }
      loadingFunc(false);
      return false;
    });
  };
  const twitterFlow = label => {
    sendAnalytics('Twitter', label);
    const isSafari = checkIsSafari();
    if (isSafari) {
      windowObjectReference = window.open('', twitterPopupName, strWindowFeatures);
    }
    if (canUseDOM) {
      loadingFunc(true);
      twitterOpen().then(response => {
        if (response.oauthToken) {
          twitterResponseObj = response;
          let apiUrl = `https://api.twitter.com/oauth/authenticate?oauth_token=${response.oauthToken}`;
          if (isSafari && windowObjectReference) {
            windowObjectReference.location.href = apiUrl;
          }
          twitterPopupOpen(apiUrl);
        } else {
          loadingFunc(false);
        }
      }, closePopUp);
    }
  };
  let facebookRedirectURI = '';
  if (canUseDOM) {
    let pathname = window.location.pathname;
    pathname = pathname.split('/');
    pathname = pathname[pathname.length - 1];
    facebookRedirectURI = window.location.origin + '/' + pathname;
  }
  const login = useGoogleLogin({
    onSuccess: tokenResponse => responseGoogle(tokenResponse),
    onError: tokenResponse => responseGoogle(tokenResponse),
    onNonOAuthError: () => {
      loadingFunc(false);
      showError(ApiError);
    },
    // https://developers.google.com/identity/oauth2/web/reference/js-reference#TokenResponse
    flow: 'implicit'
  });
  const googleClicked = function () {
    let label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    sendAnalytics('Google', label);
    loadingFunc(true);
    login();
  };
  const isBtnContainerHorizontalValue = isBtnContainerHorizontal ? 'col-12 col-md-6' : 'col-12';
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, buttons.map((_ref2, index) => {
    let {
      sm,
      text
    } = _ref2;
    if (sm === 'fb') {
      return /*#__PURE__*/React.createElement("div", {
        className: isBtnContainerHorizontalValue,
        key: index
      }, /*#__PURE__*/React.createElement(FacebookLogin, {
        appId: facebookAppId,
        fields: "name,email,picture",
        callback: responseFacebook,
        onClick: () => facebookClicked(text),
        isMobile: false,
        redirectUri: facebookRedirectURI,
        render: renderProps => /*#__PURE__*/React.createElement("button", {
          type: "button",
          onClick: renderProps.onClick,
          className: "btn btn-primary lr__social-btns lr__fb"
        }, /*#__PURE__*/React.createElement("div", {
          className: "lr__social-icon-box"
        }, /*#__PURE__*/React.createElement("img", {
          alt: text,
          className: "lr__social-icon",
          src: FB
        })), /*#__PURE__*/React.createElement("span", {
          className: "lr__social-text"
        }, text))
      }));
    } else if (sm === 'tw') {
      return /*#__PURE__*/React.createElement("div", {
        className: isBtnContainerHorizontalValue,
        key: index
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: () => twitterFlow(text),
        className: "btn btn-primary lr__social-btns lr__tw"
      }, /*#__PURE__*/React.createElement("div", {
        className: "lr__social-icon-box"
      }, /*#__PURE__*/React.createElement("img", {
        alt: text,
        className: "lr__social-icon",
        src: iconTw
      })), /*#__PURE__*/React.createElement("span", {
        className: "lr__social-text"
      }, text)));
    } else {
      return /*#__PURE__*/React.createElement("div", {
        className: isBtnContainerHorizontalValue,
        key: index
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: () => googleClicked(text),
        className: "btn btn-primary lr__social-btns lr__gp"
      }, /*#__PURE__*/React.createElement("div", {
        className: "lr__social-icon-box"
      }, /*#__PURE__*/React.createElement("img", {
        alt: text,
        className: "lr__social-icon",
        src: GP
      })), /*#__PURE__*/React.createElement("span", {
        className: "lr__social-text"
      }, text)));
    }
  })));
};
function checkIsSafari() {
  if (typeof window !== 'undefined') {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') != -1 && !(ua.indexOf('chrome') > -1);
  } else {
    return false;
  }
}
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl,
    className
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", {
    className: `${rtl ? rtlStyles : ltrStyles} ${commonStyles} ${className}`
  }, children);
};
const commonStyles = "c1fi2byx";
const ltrStyles = "lnwobsq";
const rtlStyles = "r1e81zco";
export default SocialNav;